import { SelectControl, Button, ButtonGroup, ToggleControl, PanelBody, PanelRow, Tooltip } from "@wordpress/components";
import { useEffect } from "react";
import { __ } from "@wordpress/i18n";

import BMediaUpload from "../../../../../components/BMediaUpload/BMediaUpload";
import { BControlPro } from "../../../../../../../wp-utils/v1/components/";

import posx from "../../../../../../public/images/envmaps/fishermans_bastion/posx.jpg";
import posy from "../../../../../../public/images/envmaps/fishermans_bastion/posy.jpg";
import posz from "../../../../../../public/images/envmaps/fishermans_bastion/posz.jpg";
import negx from "../../../../../../public/images/envmaps/fishermans_bastion/negx.jpg";
import negy from "../../../../../../public/images/envmaps/fishermans_bastion/negy.jpg";
import negz from "../../../../../../public/images/envmaps/fishermans_bastion/negz.jpg";

// import sdf from '../../../../../../'

const EnvironmentImage = ({ attributes, setAttributes }) => {
  const {models, environmentImage } = attributes;


  const updateModels = (key, value, index) => {
    const newModels = [...models];
    newModels[index][key] = value;
    setAttributes({ models: newModels });
  };

  return (
    <PanelBody title={__("Environment Image", "model-viewer")} initialOpen={false}>
      <PanelRow>
        <div className="environmentImages">
          <img src={posx} className={environmentImage === posx ? "image-active" : ""} onClick={(e) => setAttributes({ environmentImage: e.target.src })} />
          <img src={posy} className={environmentImage === posy ? "image-active" : ""} onClick={(e) => setAttributes({ environmentImage: e.target.src })} />
          <img src={posz} className={environmentImage === posz ? "image-active" : ""} onClick={(e) => setAttributes({ environmentImage: e.target.src })} />
          <img src={negx} className={environmentImage === negx ? "image-active" : ""} onClick={(e) => setAttributes({ environmentImage: e.target.src })} />
          <img src={negy} className={environmentImage === negy ? "image-active" : ""} onClick={(e) => setAttributes({ environmentImage: e.target.src })} />
          <img src={negz} className={environmentImage === negz ? "image-active" : ""} onClick={(e) => setAttributes({ environmentImage: e.target.src })} />
        </div>
      </PanelRow>
      <PanelRow></PanelRow>
      <BMediaUpload
        value={environmentImage}
        placeholder={__("Custom", "model-viewer")}
        onSelect={(environmentImage) => setAttributes({ environmentImage })}
        // type={["model/gltf-binary"]}
        label={__("Custom", "model-viewer")}
      />
    </PanelBody>
  );
};

export default EnvironmentImage;
